export const WEB = {
  label: 'Website',
  value: 'web',
  channel: 'web',
  disabled: false,
  navigationLimit: 8,
  tabs: ['screens', 'navigation', 'branding', 'integrations', 'profile-viewer', 'products'],
  screenTemplates: [
    {
      label: 'Authorized Home',
      template: 'AuthorizedHomePage',
      preset: '',
      thumbnail: 'web-accounts-dashboard-page.png',
      content: {},
      hasParent: false,
    },
    {
      label: 'Dashboard',
      template: 'DashboardPage',
      preset: '',
      thumbnail: 'web-dashboard-page.png',
      content: {},
      hasParent: false,
    },
    {
      label: 'Article',
      template: 'ArticlePage',
      preset: '',
      thumbnail: 'web-article-page.png',
      hasParent: false,
      content: {},
    },
    { label: 'Blog', template: 'BlogPage', preset: '', thumbnail: 'web-blog-page.png', content: {}, hasParent: false },
    {
      label: 'Cart',
      template: 'CartPage',
      preset: '',
      thumbnail: 'web-cart-page.png',
      hidden: true,
      content: {},
      hasParent: false,
    },
    {
      label: 'Category',
      template: 'CategoryPage',
      preset: '',
      thumbnail: 'web-category-page.png',
      hasParent: false,
      content: {},
    },
    { label: 'Hero', template: 'HeroPage', preset: '', thumbnail: 'web-hero-page.png', content: {}, hasParent: false },
    {
      label: 'iFrame',
      template: 'IFramePage',
      preset: '',
      thumbnail: 'web-iframe-page.png',
      content: {},
      hasParent: false,
    },
    {
      label: 'Item Selection',
      template: 'ItemSelectionPage',
      preset: '',
      thumbnail: 'web-category-page.png',
      hasParent: false,
      content: {},
    },
    {
      label: 'Product',
      template: 'ProductPage',
      preset: '',
      thumbnail: 'web-product-page.png',
      hasParent: false,
      content: {},
    },
    {
      label: 'Form',
      template: 'FormPage',
      preset: '',
      thumbnail: 'web-form-page.png',
      hasParent: true,
      content: {},
    },
    {
      label: 'Dynamic Page',
      template: 'DynamicPage',
      preset: '',
      thumbnail: 'web-dynamic-page.png',
      hasParent: true,
      content: {},
    },
    {
      label: 'Car Configurator Page',
      template: 'CarConfiguratorPage',
      preset: '',
      thumbnail: 'web-car-configurator-page.png',
      hasParent: true,
      content: {
        exteriorColors: [
          {
            color: '#FFFFFF',
            image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-white.jpeg',
            label: 'White',
            price: '$1500',
          },
          {
            color: '#F1F1F1',
            image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-silver.jpeg',
            label: 'Silver',
            price: '$1500',
          },
          {
            color: '#A62924',
            image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-red.jpeg',
            label: 'Red',
            price: '$2500',
          },
        ],
        interiorColors: [
          {
            color: '#111111',
            image:
              'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-interior-black.jpeg',
            label: 'Black',
            price: '$1500',
          },
          {
            color: '#52433F',
            image:
              'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-interior-brown.jpeg',
            label: 'Brown',
            price: '$2000',
          },
          {
            color: '#C74A38',
            image:
              'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-interior-red.jpeg',
            label: 'Red',
            price: '$2000',
          },
          {
            color: '#EB8C4B',
            image:
              'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/car-configurator/model-a-interior-orange.jpeg',
            label: 'Orange',
            price: '$2500',
          },
        ],
        contactButtonLink: 'contact-dealer',
        contactButtonLabel: 'Contact a dealer',
      },
    },
    {
      label: 'Mortgage Form',
      template: 'MortgageFormPage',
      preset: '',
      thumbnail: 'web-form-page.png',
      hasParent: true,
      content: {},
    },
  ],
  freeformTemplates: [],
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left' },
    { label: 'Center', value: 'center', default: true },
    { label: 'Right', value: 'right' },
  ],
  bannerPositionOptions: [
    { label: 'Top', value: 'top' },
    { label: 'Left', value: 'left' },
    { label: 'Center', value: 'center' },
    { label: 'Right', value: 'right' },
    { label: 'Bottom', value: 'bottom' },
  ],
  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'HeroPage',
    preset: '',
    icon: 'home',
    content: {},
  },
  defaultComponent: {},
  unknownTemplate: 'web-unknown.png',
  triggerTypes: [],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
  cartStorageOptions: [
    { label: 'Local', value: 'local', default: true },
    { label: 'AEP', value: 'aep' },
  ],
  chatBotOptions: {},
}
